import * as componentTypes from "./componentTypes";

// Redlike settings
export const ADDITIONAL_TAB_TYPE = "additional_tab_type";
export const ALTERNATIVE_FORMULAS_POSITION = "alternative_formulas_position";
export const AUTO_CLOSE_TAB = "auto_close_tab";
export const AUTOMATIC_CLIENT_START = "automatic_client_start";
export const AUTOMATIC_LOGOUT = "automatic_logout";
export const AUTOMATIC_LOGOUT_TIMEOUT = "automatic_logout_timeout";
export const AUTOMATIC_PRINT = "automatic_print";
export const BARCODES_ENABLED = "barcodes_enabled";
export const BLEND_FORMULA_AND_CODE = "settings_blend_formula_and_code";
export const BUILDING_SITE = "building_site";
export const CUSTOM_BANNER_POSITION = "custom_banner_position";
export const CUSTOM_CAN_SIZE = "custom_can_size";
export const CUSTOM_CAN_OPTION = "custom_can_option";
export const CUSTOM_CAN_SETTINGS_UNIT_GRAV = "custom_can_settings_unit_grav";
export const CUSTOM_CAN_SETTINGS_UNIT_VOL = "custom_can_settings_unit_vol";
export const CUSTOM_CAN_UNITS = "custom_can_units";
export const COLOR_PREVIEW_AS_IMAGE = "color_preview_as_image";
export const COLOR_PREVIEW_RESIZABLE = "color_preview_resizable";
export const COLORANT_BATCH_FOR_MULTIPLE_CANS = "check_available_cnt_amounts";
export const COLORANT_BATCH_NUMBER_LOGIC = "colorant_batch_number_logic";
export const COLORANT_PANEL_LIMIT = "colorant_panel_limit";
export const COLORANT_PANEL_ORDER_BY = "colorant_panel_order_by";
export const CUSTOM_FORMAT_CURRENCY = "custom_format_currency";
export const CUSTOM_FORMAT_DATE = "custom_format_date";
export const CUSTOM_FORMAT_NUMBER = "custom_format_number";
export const CUSTOM_FORMAT_TIME = "custom_format_time";
export const CUSTOM_FORMULA_FOR_MASTER_PRODUCT = "custom_formula_for_master_product";
export const CUSTOM_FORMULA_FOR_MASTER_PRODUCT_DEFAULT = "custom_formula_for_master_product_default";
export const CUSTOM_FORMULAS = "custom_formulas";
export const CUSTOM_HOME_BUTTON = "settings_custom_home_button";
export const CUSTOM_UNITS = "custom_units";
export const CUSTOMERS_ENABLED = "customers_enabled";
export const DELETE_CONFIRMATION = "delete_confirmation";
export const DISK_SPACE_NOTIFICATION = "disk_space_notification";
export const DISPENSING_ENABLED = "dispensing_enabled";
export const DISPENSING_NOTES = "dispensing_notes";
export const EDIT_COLORANT_ALLOWANCE = "edit_colorant_allowance";
export const FILE_TRANSFER = "file_transfer";
export const FILE_TRANSFER_IN_TASKS = "file_transfer_in_tasks";
export const FILE_TRANSFER_OUT_TASKS = "file_transfer_out_tasks";
export const FORMULA_AUTOMATIC_NAMING = "formula_automatic_naming";
export const FORMULA_CODE = "formula_code";
export const FORMULA_CODE_PRIMARY = "formula_code_primary";
export const PRODUCT_CODE = "product_code";
export const PRODUCT_GROUPS = "product_groups";
export const FORMULA_COLOR_PREVIEW = "formula_color_preview";
export const FANDECK_GROUPS = "fandeck_groups";
export const FORMULA_INFO_DATA = "info_types";
export const FORMULA_INFO_ITEM_IN_RGB_PREVIEW = "settings_info_item_in_rgb_preview";
export const FORMULA_MODIFICATION_PANEL = "formula_modification_panel_enabled";
export const FORMULA_NAME = "formula_name";
export const FORMULA_NOTES = "formula_notes";
export const FORMULA_PREVIEW = "formula_preview";
export const FORMULA_PROPERTIES_POSITION = "formula_properties_position";
export const FORMULA_STATUS_PANEL = "formula_status_panel_enabled";
export const FORMULA_UNITS = "formula_units";
export const GDPR_ENABLED = "gdpr_enabled";
export const GENERATE_COLOR_PREVIEW = "generate_color_preview";
export const HELP = "help";
export const HELP_LINK = "help_link";
export const HELPER_AUTO_CHECK = "helper_auto_check";
export const HELPER_AUTO_CHECK_INTERVAL = "helper_auto_check_interval";
export const HELPER_AUTO_DOWNLOAD = "helper_auto_download";
export const HELPER_AUTO_FORCE_INSTALL = "helper_auto_force_install";
export const HELPER_AUTO_INSTALL = "helper_auto_install";
export const HELPER_AUTO_INSTALL_DELAY = "helper_auto_install_delay";
export const HELPER_AUTO_INSTALL_NEW_DBS = "helper_auto_install_new_dbs";
export const HELPER_AUTO_NIGHT_CHECK = "helper_auto_night_check";
export const HELPER_AUTO_REBOOT_DELAY = "helper_auto_reboot_delay";
export const HISTORICAL_FORMULAS_POSITION = "historical_formulas_position";
export const IMAGES_SOURCE = "images_source";
export const INFO_PANEL_RESIZABLE = "info_panel_resizable";
export const INFO_PANEL_TAB = "info_panel_tab";
export const INIT_TAB_TYPE = "init_tab_type";
export const KEYBOARD = "keyboard";
export const KEYBOARD_SHORTCUTS = "keyboard_shortcuts";
export const KIOSK = "kiosk";
export const LANGUAGE = "language";
export const LIGHT_ENABLED = "light_enabled";
export const LOCALE = "locale";
export const LOCK_COMPUTER = "lock_pc";
export const VIRTUAL_KEYBOARD_ENABLED = "virtual_keyboard_enabled";
export const SETTINGS_MANUAL_ADDITION_UNIT = "settings_manual_addition_unit";
export const MARGIN_MARKUP = "margin_markup";
export const MASTER_PRODUCT_NAME = "master_product_name";
export const MASTER_PRODUCT_SIBLINGS_TABLE = "master_product_siblings_table";
export const MATCHING_INFO_CR = "matching_info_cr";
export const MATCHING_INFO_DELTA_E1 = "matching_info_delta_e1";
export const MATCHING_INFO_DELTA_E2 = "matching_info_delta_e2";
export const MATCHING_INFO_DELTA_E3 = "matching_info_delta_e3";
export const MATCHING_INFO_DIN = "matching_info_din";
export const MATCHING_INFO_LRV = "matching_info_lrv";
export const MATCHING_INFO_RMS = "matching_info_rms";
export const MATCHING_OPTIONS_COLORANTS = "matching_options_colorants";
export const MATCHING_OPTIONS_COLORFILE = "matching_options_colorfile";
export const MATCHING_OPTIONS_SORT_RESULTS = "matching_options_sort_results";
export const MATCHING_ROW_COUNT = "matching_row_count";
export const MORE_INFO_INTERNAL = "more_info_internal";
export const NAVIGATION_ITEMS = "navigation_items_ordered";
export const NUMBER_OF_TABS = "number_of_tabs";
export const ORDERING_ENABLED = "ordering_enabled";
export const ORDER_MODAL_ENABLED = "order_modal_enabled";
export const ORDER_SEARCH_ITEMS = "order_search_items";
export const OVERWRITE_HELPER_CONFIG = "overwrite_helper_config";
export const OVERWRITE_LAST_TAB = "overwrite_last_tab";
export const OVERWRITE_LOGO = "overwrite_logo";
export const OVERWRITE_MACHINE_CONFIG = "overwrite_machine_config";
export const PARTIAL_UPDATE_INACTIVITY_TIMER = "partial_update_inactivity_auto_action_timer";
export const PARTIAL_UPDATE_REMIND_INTERVAL = "partial_update_remind_me_later_interval";
export const PRICING_ENABLED = "pricing_enabled";
export const PRICE_TYPES = "price_types";
export const PRICE_VISIBILITY_TYPES = "price_visibility_types";
export const PRINT_AS_IMAGE = "print_as_image";
export const PRINT_AFTER_DISPENSING = "print_after_dispensing";
export const PRINT_BEFORE_DISPENSING = "print_before_dispensing";
export const PRINT_ENABLED = "print_enabled";
export const PRINT_ON_REQUEST = "print_on_request";
export const PRINT_TASKS_AFTER_DISPENSING = "print_tasks_after_dispensing";
export const PRINT_TASKS_BEFORE_DISPENSING = "print_tasks_before_dispensing";
export const PRINTER = "printer";
export const PRINTER_TEMPLATE = "printer_template";
export const PRINTER_TEMPLATE_QUICKTINT = "printer_template_quicktint";
export const PRODUCT_FILES_SOURCE = "product_files_source";
export const PRODUCT_IMAGE_PREVIEW = "product_image_preview";
export const QUALITY_CONTROL_COLOR_DIFFERENCE = "quality_control_color_difference";
export const QUALITY_CONTROL_DELTA_A = "quality_control_delta_a";
export const QUALITY_CONTROL_DELTA_B = "quality_control_delta_b";
export const QUALITY_CONTROL_DELTA_E = "quality_control_delta_e";
export const QUALITY_CONTROL_DELTA_L = "quality_control_delta_l";
export const QUALITY_CONTROL_ENABLED = "quality_control_enabled";
export const QUALITY_CONTROL_METAMERISM = "quality_control_metamerism";
export const QUICK_TINT_SORTING_TYPE = "quick_tint_sorting_type";
export const QUICK_TINT_WINDOW_CLOSE_AFTER_DISPENSING = "quick_tint_close_after_dispensing";
export const ROUNDING = "rounding";
export const RCC_BARCODE_REFILL = "rcc_barcode_refill";
export const RCC_BASE_CAN_BARCODE_VALIDATION = "rcc_base_can_barcode_validation";
export const RCC_CHECK_CAN_BEFORE_DISPENSE = "rcc_check_can_before_dispense";
export const RCC_CHECK_OVERFILL = "rcc_check_overfill";
export const RCC_DISPENSE_INVALID_COLORANTS = "rcc_dispense_invalid_colorants";
export const RCC_MANUAL_COLORANT_ADDITION = "rcc_manual_colorant_addition";
export const RCC_MINIMAL_DISPENSE_AMOUNT = "rcc_minimal_dispense_amount";
export const RCC_PLACE_CAN_SENSOR = "rcc_place_can_sensor";
export const RCC_PLACE_CAN_SENSOR_DELAY = "rcc_place_can_sensor_delay";
export const RCC_REMOVE_CAN_SENSOR = "rcc_remove_can_sensor";
export const RCC_REMOVE_CAN_SENSOR_DELAY = "rcc_remove_can_sensor_delay";
export const RCC_SKIP_PLACE_CAN_DIALOG = "rcc_skip_place_can_dialog";
export const RCC_SKIP_REMOVE_CAN_DIALOG = "rcc_skip_remove_can_dialog";
export const RCC_SPLIT_FORMULA = "rcc_split_formula";
export const RCC_TMC_ENABLED = "rcc_tmc_enabled";
export const RCC_UNIT = "rcc_unit";
export const RCC_VALIDATE_COLORANTS_DURING_INIT = "rcc_validate_colorants_during_init";
export const SEARCH_CHEAPER_COLORS = "search_cheaper_colors";
export const SEARCH_PANEL_BASE = "search_panel_base";
export const SEARCH_PANEL_BASE_SIZE = "search_panel_base_size";
export const SEARCH_PANEL_BIPP = "search_panel_bipp";
export const SEARCH_PANEL_BIPP_SIZE = "search_panel_bipp_size";
export const SEARCH_PANEL_DROP_DOWN_CALCULATE = "search_panel_drop_down_calculate";
export const SEARCH_PANEL_FANDECK_SIZE = "search_panel_fandeck_size";
export const SEARCH_PANEL_FORMULA_SIZE = "search_panel_formula_size";
export const SEARCH_PANEL_ORDER = "search_panel_order";
export const SEARCH_PANEL_ORDER_BY_DISTANCE = "search_panel_order_by_distance";
export const SEARCH_PANEL_PRODUCT = "search_panel_product";
export const SEARCH_PANEL_PRODUCT_SIZE = "search_panel_product_size";
export const SEARCH_PANEL_QUICK_SELECT = "search_panel_without_confirmation";
export const SCREENSAVER_TIMEOUT = "screensaver_timeout";
export const SHOTS_COEF = "shots_coef";
export const SHOTS_NAME = "shots_name";
export const SOFTWARE_NAME = "software_name";
export const SOFTWARE_NAME_LIGHT = "software_name_light";
export const SOUND_ENABLED = "sound_enabled";
export const SPECTRO_ENABLED = "spectro_enabled";
export const STOCK_DATABASE_FILTER = "stock_database_filter";
export const STOCK_TABLE_ORDER_BY = "stock_table_order_by";
export const STYLE = "style";
export const TABS_ENABLED = "tabs_enabled";
export const TABS_MEMORY = "tabs_memory";
export const TINTOMETRIC_SYSTEM = "tintometric_system";
export const TINTOMETRIC_SYSTEMS_ENABLED = "tintometric_systems_and_formula_ranking_enabled";
export const UFI_CODE_BASE_VALIDATION = "ufi_code_base_validation";
export const UFI_CODE_LOGIC = "ufi_code_logic";
export const UFI_CODE_MIN_AMOUNT_GRAV_PERCENT = "ufi_code_min_amont_grav_percent";
export const UFI_CODE_MIN_GRAV_PERCENT = "ufi_code_min_grav_percent";
export const USER_IDENTIFICATION = "user_identification";
export const VISIBLE_UNITS = "visible_units";
export const ZOOM = "zoom";
export const ACTIVE_FORMULA_UNIT = "settings_active_formula_unit";
export const FTS = "fts";

export const RECIRCULATION_TIME = "settings_recirculation_time";
export const RECIRCULATION_SPEED = "settings_recirculation_speed";
export const STIRRING_TIME = "settings_stirring_time";
export const STIRRING_SPEED = "settings_stirring_speed";
export const CLEANING_TIME = "settings_cleaning_time";

// Price settings
export const PRICING_LOCAL_PRICES = "enable_local_prices";
export const PRICING_PRICE_GROUPS_ENABLED = "enable_price_groups";
export const PRICING_NUMBER_PRICE_GROUPS = "num_price_groups";
export const PRICING_PRICE_DEFINITION = "price_definition";
export const PRICING_PRICE_UNIT_DEFINITION = "price_unit_definition";
export const PRICING_USE_MARGIN = "use_margin";
export const PRICING_USE_MARKUP = "use_markup";
export const PRICING_USE_DISCOUNT = "use_discount";

// Weber settings
export const WEBER_CAN_BIG_LOWER_BOUND = "weber_can_big_lower_bound";
export const WEBER_CAN_BIG_UPPER_BOUND = "weber_can_big_upper_bound";
export const WEBER_CAN_COATING_LOWER_BOUND = "weber_can_coating_lower_bound";
export const WEBER_CAN_COATING_UPPER_BOUND = "weber_can_coating_upper_bound";
export const WEBER_CAN_LABORATORY_LOWER_BOUND = "weber_can_laboratory_lower_bound";
export const WEBER_CAN_LABORATORY_UPPER_BOUND = "weber_can_laboratory_upper_bound";
export const WEBER_CAN_SMALL_LOWER_BOUND = "weber_can_small_lower_bound";
export const WEBER_CAN_SMALL_UPPER_BOUND = "weber_can_small_upper_bound";
export const WEBER_COATING_NAMES = "weber_coating_names";
export const WEBER_PLASTER_NAMES = "weber_plaster_names";

// COLOR PANEL values
export const COLOR_TAB_COMPATIBLE_ONLY = "color_tab_compatible_only";
export const COLOR_TAB_FORMULA_CODE = "color_tab_formula_code";
export const COLOR_TAB_FORMULA_NAME = "color_tab_formula_name";
export const COLOR_TAB_NOTE_ICONS = "color_tab_note_icons";
export const COLOR_TAB_ORDER_BY = "color_tab_order_by";
export const COLOR_TAB_ROW_COUNT = "color_tab_row_count";
export const COLOR_TAB_WARNING_ICON = "color_tab_warning_icon";

// TABLE COLUMNS visibility
export const TABLE_ANSWER = "table_answer";
export const TABLE_BASE = "table_base";
export const TABLE_BIPP = "table_bipp";
export const TABLE_BUILDING_SITE = "table_building_site";
export const TABLE_CLIENT_NAME = "table_client_name";
export const TABLE_COLOR_NAME = "table_color_name";
export const TABLE_COMMENT = "table_color_name";
export const TABLE_CREATED = "table_created";
export const TABLE_CUSTOMER = "table_customer";
export const TABLE_DATE = "table_date";
export const TABLE_FANDECK = "table_fandeck";
export const TABLE_FORMULA_CODE = "table_formula_code";
export const TABLE_FORMULA_NAME = "table_formula_name";
export const TABLE_MORE_INFO = "table_more_info";
export const TABLE_MORE_INFO_INTERNAL = "table_more_info_internal";
export const TABLE_OPERATOR = "table_operator";
export const TABLE_PACKAGE = "table_package";
export const TABLE_PRODUCT = "table_product";
export const TABLE_QUALITY_CONTROL = "table_quality_control";
export const TABLE_QUANTITY = "table_quantity";
export const TABLE_STATUS = "table_status";
export const TABLE_SUBJECT = "table_subject";
export const TABLE_TICKET_ID = "table_ticket_id";
export const TABLE_TYPE = "table_type";

// MATCHING TABLE COLUMNS visibility
export const MATCHING_TABLE_BASE = "matching_table_base";
export const MATCHING_TABLE_COLORANTS = "matching_table_colorants";
export const MATCHING_TABLE_CR = "matching_table_cr";
export const MATCHING_TABLE_DELTA_E1 = "matching_table_delta_e1";
export const MATCHING_TABLE_DELTA_E2 = "matching_table_delta_e2";
export const MATCHING_TABLE_DELTA_E3 = "matching_table_delta_e3";
export const MATCHING_TABLE_DIN = "matching_table_din";
export const MATCHING_TABLE_LRV = "matching_table_lrv";
export const MATCHING_TABLE_PRICE = "matching_table_price";
export const MATCHING_TABLE_RMS = "matching_table_rms";

// OPTIONS
export const NAVIGATION_ITEMS_OPTIONS = "navigation_items";

// Price definition
export const PURCHASE_ONLY = "purchase_only";
export const SELL_ONLY = "sell_only";
export const BOTH_PURCHASE_PRIMARY = "both_purchase_primary";
export const BOTH_SELL_PRIMARY = "both_sell_primary";

// DEFAULT values
export const DEFAULT_ROUNDING = 2;
export const DEFAULT_ZOOM = 100;
export const DEFAULT_CURRENCY_CODE = "EUR";
export const DEFAULT_CURRENCY_SYMBOL = "â¬";

// FORMULA_PREVIEW options
export const PREVIEW_IMAGE = "image";
export const PREVIEW_COLOR = "color";
export const PREVIEW_MORE_INFO = "more_info";

// INFO_PANEL_TAB options
export const INFO_PANEL_PACKAGE = "info_panel_package";
export const INFO_PANEL_MORE = "info_panel_more";

// PRICE_VISIBILITY_TYPES options
export const WITH_AND_WITHOUT_VAT_OPTION = "with_and_without_vat_option";
export const WITH_VAT_OPTION = "with_vat_option";
export const WITHOUT_VAT_OPTION = "without_vat_option";

// NAVIGATION_ITEMS options
export const NAV_ITEM_BARCODE_SCAN = "barcodeScan";
export const NAV_ITEM_CANISTER_BARCODE = "canisterBarcode";
export const NAV_ITEM_CANISTER_LEVEL = "canisterLevel";
export const NAV_ITEM_CANISTERS = "canisters";
export const NAV_ITEM_CLEAN = "clean";
export const NAV_ITEM_COLOR_SEARCH_TAB = "colorSearchTab";
export const NAV_ITEM_COLOR_TAB = "colorTab";
export const NAV_ITEM_COLORANT_REFILL_HISTORY = "colorantRefillHistory";
export const NAV_ITEM_CUSTOM_FORMULA = "customFormula";
export const NAV_ITEM_CUSTOMERS = "customers";
export const NAV_ITEM_FAVORITES = "favorites";
export const NAV_ITEM_HELP = "help";
export const NAV_ITEM_HIDE_ITEMS = "hideItems";
export const NAV_ITEM_HOME = "home";
export const NAV_ITEM_MACHINE_RESET = "machineReset";
export const NAV_ITEM_MATCHING = "matching";
export const NAV_ITEM_MY_ORDERS = "orders";
export const NAV_ITEM_ORDERS_HISTORY = "ordersHistory";
export const NAV_ITEM_PURGE = "purge";
export const NAV_ITEM_QUICK_TINT = "quickTint";
export const NAV_ITEM_SEARCH_NEW_FORMULA = "searchNewFormula";
export const NAV_ITEM_SPECTRO = "spectro";
export const NAV_ITEM_STATISTICS = "statistics";
export const NAV_ITEM_STIR = "stir";
export const NAV_ITEM_TICKETING = "ticketing";
export const NAV_ITEM_TO_DISPENSE = "toDispense";

// ORDER_SEARCH options
export const ORDER_SEARCH_BASE = "base";
export const ORDER_SEARCH_CUSTOMER = "customer";
export const ORDER_SEARCH_DATABASE = "database";
export const ORDER_SEARCH_FANDECK = "fandeck";
export const ORDER_SEARCH_FORMULA = "formula";
export const ORDER_SEARCH_NOTE = "note";
export const ORDER_SEARCH_ORDER_ID = "orderId";
export const ORDER_SEARCH_PACKAGE = "package";
export const ORDER_SEARCH_PRODUCT = "product";

// COLOR_PANEL_SORTING_TYPE options
export const COLOR_PANEL_SORTING_TYPE_FORMULA_NAME = "formula_name";
export const COLOR_PANEL_SORTING_TYPE_FORMULA_CODE = "formula_code";
export const COLOR_PANEL_SORTING_TYPE_BRIGHTNESS = "brightness";
export const COLOR_PANEL_SORTING_TYPE_COLOR_TONE = "color_tone";
export const COLOR_PANEL_SORTING_TYPE_FANDECK_POSITION = "fandeck_position";

// QUICK_TINT_SORTING_TYPE options
export const QUICK_TINT_SORTING_TYPE_ALPHA = "alphabeticaly";
export const QUICK_TINT_SORTING_TYPE_CANISTER = "canister";

// UNIT options
export const UNIT_DENSITY = "kg/L";
export const UNIT_G = "g";
export const UNIT_IMP_GALLON = "Imp. gallon";
export const UNIT_IMP_QUARTS = "Imp. quart";
export const UNIT_KG = "kg";
export const UNIT_L = "L";
export const UNIT_MANUAL = "manual";
export const UNIT_ML = "ml";
export const UNIT_SHOT = "shot";
export const UNIT_US_GALLON = "U.S. gallon";
export const UNIT_US_QUARTS = "U.S. quart";

export const UNIT_L_ID = 1;
export const UNIT_KG_ID = 2;

export const SECONDS = "s";

// Intergamma settings
export const INTERGAMMA_COLOR_FANDECK_WIZARD = "intergamma_color_fandeck_wizard";
export const INTERGAMMA_MACHINE_SORTING_ORDERS = "intergamma_machine_sorting_orders";
export const INTERGAMMA_ORDER_QUICK_SELECT = "intergamma_order_quick_select";

// Keyboard shortcuts
export const SHORTCUT_CHANGELOG = "changelog";
export const SHORTCUT_CLOSE_TAB = "close_tab";
export const SHORTCUT_DISPENSING = "dispensing";
export const SHORTCUT_NEW_TAB = "new_tab";
export const SHORTCUT_QUICK_TINT = "quick_tint";
export const SHORTCUT_SPECTRO = "spectro";
export const SHORTCUT_CANISTERS = "canisters";
export const SHORTCUT_MY_ORDERS = "my_orders";
export const SHORTCUT_ORDER = "order";
export const SHORTCUT_PRINT = "print";
export const SHORTCUT_TO_DISPENSE = "to_dispense";
export const SHORTCUT_LOG_IN_AS = "log_in_as";
export const SHORTCUT_HINT_TOOLTIPS = "hint_tooltips";
export const SHORTCUTS_NAMES = [
    SHORTCUT_CANISTERS,
    SHORTCUT_CHANGELOG,
    SHORTCUT_CLOSE_TAB,
    SHORTCUT_DISPENSING,
    SHORTCUT_HINT_TOOLTIPS,
    SHORTCUT_LOG_IN_AS,
    SHORTCUT_MY_ORDERS,
    SHORTCUT_NEW_TAB,
    SHORTCUT_ORDER,
    SHORTCUT_PRINT,
    SHORTCUT_QUICK_TINT,
    SHORTCUT_SPECTRO,
    SHORTCUT_TO_DISPENSE
];

// WEBER default values
export const WEBER_DEFAULT_CAN_BIG_LOWER_BOUND = 125;
export const WEBER_DEFAULT_CAN_BIG_UPPER_BOUND = 99999;
export const WEBER_DEFAULT_CAN_COATING_LOWER_BOUND = 5;
export const WEBER_DEFAULT_CAN_COATING_UPPER_BOUND = 99999;
export const WEBER_DEFAULT_CAN_LABORATORY_LOWER_BOUND = 0;
export const WEBER_DEFAULT_CAN_LABORATORY_UPPER_BOUND = 4.5;
export const WEBER_DEFAULT_CAN_SMALL_LOWER_BOUND = 25;
export const WEBER_DEFAULT_CAN_SMALL_UPPER_BOUND = 106;
export const WEBER_DEFAULT_COATING_NAMES = ["nater", "Nater"];
export const WEBER_DEFAULT_PLASTER_NAMES = ["omitka", "Omitka"];

// USER helping constants
export const SELECTED_GROUPS = "selected_groups";
export const UNSELECTED_GROUPS = "unselected_groups";

// Color Tab Tile Grid
export const TILE_GRID_20 = 20;
export const TILE_GRID_40 = 40;
export const TILE_GRID_84 = 84;
export const TILE_GRID_150 = 150;

// Color Tab Settings
export const ORDER_BY_COLOR_NAME = "color_priority_name";
export const ORDER_BY_COLOR_CODE = "color_code";
export const ORDER_BY_COLOR_HUE = "color_hue";
export const ORDER_BY_FANDECK_POSITION = "fandeck_position";

// Color Panel
export const ORDER_BY_AMOUNT = "amount";
export const ORDER_BY_NAME = "name";
export const ORDER_BY_DATABASE = "database";

// Color Competitive Search Settings
export const COMPETITIVE_COLOR_SEARCH = "competitive_color_search";
export const NUMBER_OF_COMPETITIVE_COLORS = "number_of_competitive_colors";
export const MAX_TOLERANCE_FOR_COMPETITIVE_COLORS = "max_tolerance_for_competitive_colors";

export const CUSTOM_BANNER_POSITION_TOP = "top";
export const CUSTOM_BANNER_POSITION_BOTTOM = "bottom";

export const OPTION_NONE = "none";

// colorant BATCH number
export const COLORANT_BATCH_NUMBER_LOGIC_DISABLED = 0;
export const COLORANT_BATCH_NUMBER_LOGIC_LAST_REFILL_CANISTER = 1;
export const COLORANT_BATCH_NUMBER_LOGIC_HIGHEST_CONCENTRATION_CANISTER = 2;

// Key names
export const KEY_NAME_SHIFT = "Shift";
export const KEY_NAME_CTRL = "Ctrl";

// UFI code
export const UFI_CODE_LOGIC_DISABLED = 0;
export const UFI_CODE_LOGIC_DB_VALUES = 1;
export const UFI_CODE_LOGIC_HIGHEST_CONCENTRATION_CANISTER = 2;
export const UFI_CODE_LOGIC_LAST_REFILL_CANISTER = 3;

export const UFI_CODE_BASE_VALIDATION_DISABLED = 0;
export const UFI_CODE_BASE_VALIDATION_ASK = 1;
export const UFI_CODE_BASE_VALIDATION_ENABLED = 2;

export const PRINT_TASK_ACTION_ALL = "all";
export const PRINT_TASK_ACTION_STANDARD = "standard";
export const PRINT_TASK_ACTION_QUICK_TINT = "quick_tint";

export const VALIDATE_COLORANT_BASE_RULES = "check_colorant_base_rules";
export const VALIDATE_TOTAL_CNT_AMOUNTS = "check_total_cnt_amounts";
export const VALIDATE_MIN_DOSABLE_AMOUNT = "check_min_dosable_amount";
export const VALIDATE_OVERFILL = "check_overfill";
export const DISPENSING_WITH_ERRORS_ENABLED = "dispensing_with_errors_enabled";

export const RESIZABLE_ON_FOCUS = "on_focus";
export const RESIZABLE_AVAILABLE = "available";

// Custom package units
export const ALL_UNITS = "all_units";
export const VOLUMETRIC_ONLY = "volumetric_only";
export const GRAVIMETRIC_ONLY = "gravimetric_only";
export const PRODUCT_DEPENDENT = "product_dependent";

// File transfer kinds
export const FILE_TRANSFER_KIND_CUSTOMER = "customer";
export const FILE_TRANSFER_KIND_CUSTOM_FORMULA = "custom_formula";
export const FILE_TRANSFER_KIND_HISTORY = "history";
export const FILE_TRANSFER_KIND_ORDER = "order";

// File transfer task types
export const FILE_TRANSFER_IN_TASK = "in";
export const FILE_TRANSFER_OUT_TASK = "out";

// File transfer protocols
export const PROTOCOL_FOLDER = "folder";
export const PROTOCOL_FTP = "ftp";
export const PROTOCOL_FTPS = "ftps";
export const PROTOCOL_REDLIKE_STORAGE = "redlike_storage";
export const PROTOCOL_SFTP = "sftp";

// File transfer import formats
export const DESO_CUSTOM_FORMULA_XML = "deso_custom_formula_xml";
export const DESO_CUSTOM_FORMULA_SIMPLE_XML = "deso_custom_formula_simple_xml";
export const DESO_CUSTOMER_XML = "deso_customer_xml";
export const DESO_HISTORY_XML = "deso_history_xml";
export const DESO_ORDER_XML = "deso_order_xml";

// Notification types
export const NOTIFICATION_FLASH_MESSAGE = "flash_message";
export const NOTIFICATION_DIALOG = "dialog";

// File transfer start types
export const START_TYPE_AUTO = "auto";
export const START_TYPE_MANUAL = "manual";

// Formatting
export const FORMAT_CODE_PREFIX = "code_prefix";
export const FORMAT_CODE_POSTFIX = "code_postfix";
export const FORMAT_SYMBOL_PREFIX = "symbol_prefix";
export const FORMAT_SYMBOL_POSTFIX = "symbol_postfix";

// File or image source
export const SOURCE_LOCAL = "local";
export const SOURCE_ASK = "ask";
export const SOURCE_ONLINE = "online";

// RCC config options
export const RCC_ASK = "ask";
export const RCC_COLORANT_PACKAGE = "colorant_package";
export const RCC_DISABLED = "disabled";
export const RCC_ENABLED = "enabled";

// Stock
export const STOCK_TABLE_ORDER_BY_COLORANT_NAME = 0;
export const STOCK_TABLE_ORDER_BY_STOCK_LEVEL = 1;
export const STOCK_TABLE_ORDER_BY_ORDER_NEED = 2;

// Historical/alternative formulas position
export const POSITION_COLORANT_PANEL = "colorant_panel";
export const POSITION_BELOW_MORE_INFO = "below_more_info";

// Formula properties position
export const POSITION_FORMULA_STATUS_PANEL = "formula_status_panel";
export const POSITION_FORMULA_MORE_INFO_PANEL = "formula_more_info_panel";

// Quality control - color difference
export const CIE_LAB_1976 = "cie_lab_1976";
export const CIE_LAB_2000 = "cie_lab_2000";
export const CMC = "cmc";

export const CIE_LAB_1976_RESPONSE = "cie_1976Difference";
export const CIE_LAB_2000_RESPONSE = "cie_2000Difference";
export const CMC_RESPONSE = "cmcDifference";

// Order of items for search panel in color search tab
export const SEARCH_PANEL_COLOR_SEARCH_ORDER = [
    componentTypes.SEARCH_PANEL_FANDECK,
    componentTypes.SEARCH_PANEL_FORMULA_NAME,
    componentTypes.SEARCH_PANEL_PRODUCT
];
export const SEARCH_PANEL_COLOR_SEARCH_ORDER_WITH_COLOR_CODE = [
    componentTypes.SEARCH_PANEL_FANDECK,
    componentTypes.SEARCH_PANEL_FORMULA,
    componentTypes.SEARCH_PANEL_PRODUCT
];
